module.exports = __webpack_public_path__ + "static/media/ZM.927f193f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/ZM.svg
// module id = 2296
// module chunks = 7